(() => {
  //console.log('🛒 Recharge sale enhancer started');

  const processedAttr = 'data-launchpad-sale-enhanced';

  function findInShadowRoots(selector, root = document) {
    const direct = root.querySelector(selector);
    if (direct) return direct;

    const elements = root.querySelectorAll('*');

    for (const element of elements) {
      if (element.shadowRoot) {
        const found = findInShadowRoots(selector, element.shadowRoot);
        if (found) return found;
      }
    }

    return null;
  }

  function findAllInShadowRoots(selector, root = document, results = []) {
    results.push(...root.querySelectorAll(selector));

    const elements = root.querySelectorAll('*');

    for (const element of elements) {
      if (element.shadowRoot) {
        findAllInShadowRoots(selector, element.shadowRoot, results);
      }
    }

    return results;
  }

  function formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';

    return new Intl.NumberFormat(
      document.documentElement.lang || 'en-US',
      {
        style: 'currency',
        currency
      }
    ).format(cents / 100);
  }

  async function getCart() {
    const root = window.Shopify?.routes?.root || '/';

    const response = await fetch(root + 'cart.js', {
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('Unable to load /cart.js');
    }

    return response.json();
  }

  async function getProduct(handle) {
    const root = window.Shopify?.routes?.root || '/';

    const response = await fetch(
      root + 'products/' + encodeURIComponent(handle) + '.js',
      {
        credentials: 'same-origin'
      }
    );

    if (!response.ok) {
      throw new Error(`Unable to load product ${handle}`);
    }

    return response.json();
  }

  function alreadyDiscountedByRecharge(line) {
    return Boolean(
      line.querySelector('.line-through') ||
      line.querySelector('[part~="discount"]') ||
      line.textContent.includes('Saving ')
    );
  }

  function enhanceLine(line, compareAtPrice, currentPrice) {
    if (!compareAtPrice || compareAtPrice <= currentPrice) return;

    if (alreadyDiscountedByRecharge(line)) return;

    const moneyElements = line.querySelectorAll('[part="money"]');

    if (!moneyElements.length) return;

    const currentMoney = moneyElements[0];
    const container = currentMoney.parentElement;

    if (!container) return;

    if (container.hasAttribute(processedAttr)) return;

    const savingPercent = Math.round(
      ((compareAtPrice - currentPrice) / compareAtPrice) * 100
    );

    container.setAttribute(processedAttr, 'true');

    container.innerHTML = `
      <span class="sr-only">
        Original price: ${formatMoney(compareAtPrice)}
      </span>

      <span
        part="money"
        class="text-storefront-drawer-muted line-through mr-2"
      >
        ${formatMoney(compareAtPrice)}
      </span>

      <span class="sr-only">
        Price after discount: ${formatMoney(currentPrice)}
      </span>

      <span
        part="money discount"
        class="text-storefront-drawer-accent font-semibold"
      >
        ${formatMoney(currentPrice)}
      </span>

      <div
        class="text-xs text-right text-storefront-drawer-accent font-semibold"
      >
        Saving ${savingPercent}%
      </div>
    `;
  }

  async function enhanceRechargeCart() {
    const drawer = findInShadowRoots('#cart-drawer');

    //console.log('Recharge drawer found:', drawer);

    if (!drawer) return;

    const cart = await getCart();

    //console.log('Shopify cart:', cart);

    const rechargeLines = [
      ...drawer.querySelectorAll('[role="listitem"]')
    ].filter(line =>
      line.querySelector('img') &&
      line.querySelector('[part="money"]')
    );

    //console.log('Recharge lines:', rechargeLines);

    const products = new Map();

    for (const item of cart.items) {
      if (!products.has(item.handle)) {
        try {
          products.set(
            item.handle,
            await getProduct(item.handle)
          );
        } catch (error) {
          console.warn(
            '[Recharge sale prices] Product fetch failed:',
            item.handle,
            error
          );
        }
      }
    }

    cart.items.forEach((cartItem, index) => {
      const line = rechargeLines[index];
      if (!line) return;

      const product = products.get(cartItem.handle);
      if (!product) return;

      const variant = product.variants.find(
        variant =>
          Number(variant.id) === Number(cartItem.variant_id)
      );

      if (!variant) return;

      const compareAtPrice =
        Number(variant.compare_at_price || 0);

      const currentPrice =
        Number(cartItem.final_price ?? cartItem.price);

      /*console.log(
        'Sale check:',
        cartItem.product_title,
        {
          currentPrice,
          compareAtPrice
        }
      );*/

      enhanceLine(
        line,
        compareAtPrice,
        currentPrice
      );
    });
  }

  let timer;

  function scheduleEnhancement() {
    clearTimeout(timer);

    timer = setTimeout(() => {
      enhanceRechargeCart().catch(error => {
        console.warn('[Recharge sale prices]', error);
      });
    }, 300);
  }

  /*
   * Observe the document for Recharge mounting/remounting
   * its storefront component.
   */
  const observer = new MutationObserver(scheduleEnhancement);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.addEventListener('load', scheduleEnhancement);
  document.addEventListener('DOMContentLoaded', scheduleEnhancement);

  /*
   * Recharge can render after normal page load,
   * so perform a few initial checks too.
   */
  setTimeout(scheduleEnhancement, 500);
  setTimeout(scheduleEnhancement, 1500);
  setTimeout(scheduleEnhancement, 3000);
})();